import { showLayoutManagerPopup } from './layoutManager';
import useLayoutStore from '../Store/layoutStore';

function errorText(error, fallback) {
  return error instanceof Error && error.message ? error.message : fallback;
}

function styledButton(label) {
  const button = document.createElement('button');
  button.type = 'button';
  button.textContent = label;
  Object.assign(button.style, {
    backgroundColor: '#000',
    color: '#B18800',
    border: '1px solid #B18800',
    padding: '6px 10px',
    borderRadius: '4px',
    cursor: 'pointer',
  });
  return button;
}

function readWidgetState(widget) {
  return new Promise((resolve, reject) => {
    try {
      widget.save((content) => {
        if (!content || typeof content !== 'object') {
          reject(new Error('TradingView did not return a chart layout.'));
          return;
        }
        resolve(content);
      });
    } catch (error) {
      reject(error);
    }
  });
}

export function showSaveLayoutPopup(widget, memberId) {
  const existingModal = document.querySelector('[data-chart-layout-modal="save"]');
  if (existingModal) {
    existingModal.focus?.();
    return existingModal;
  }

  const modal = document.createElement('div');
  modal.dataset.chartLayoutModal = 'save';
  Object.assign(modal.style, {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#000',
    color: '#B18800',
    border: '1px solid #B18800',
    padding: '20px',
    zIndex: '10000',
    borderRadius: '8px',
    minWidth: '300px',
    boxShadow: '0 0 10px #B18800',
  });

  const label = document.createElement('label');
  label.textContent = 'Layout Name:';
  label.style.display = 'block';
  label.style.marginBottom = '8px';

  const input = document.createElement('input');
  input.type = 'text';
  input.setAttribute('aria-label', 'Layout name');
  Object.assign(input.style, {
    width: '100%',
    padding: '6px',
    marginBottom: '12px',
    backgroundColor: '#111',
    color: '#B18800',
    border: '1px solid #B18800',
    borderRadius: '4px',
  });

  const error = document.createElement('p');
  error.setAttribute('role', 'alert');
  error.style.minHeight = '1.2em';
  error.style.margin = '0 0 12px';

  const buttonRow = document.createElement('div');
  buttonRow.style.display = 'flex';
  buttonRow.style.justifyContent = 'space-between';
  const saveButton = styledButton('Save');
  const cancelButton = styledButton('Cancel');

  saveButton.onclick = async () => {
    error.textContent = '';
    const name = input.value.trim();
    if (!name) {
      error.textContent = 'Enter a layout name.';
      return;
    }
    if (memberId === undefined || memberId === null || String(memberId).trim() === '') {
      error.textContent = 'Member ID is required.';
      return;
    }

    saveButton.disabled = true;
    try {
      const content = await readWidgetState(widget);
      const symbol = widget.chart().symbol();
      const payload = { memberId, name, content, symbol };
      JSON.stringify(payload);
      await useLayoutStore.getState().saveLayout(payload);
      try {
        await useLayoutStore.getState().loadLayouts(memberId);
      } catch (refreshError) {
        error.textContent = `Layout saved, but the list could not refresh: ${errorText(
          refreshError,
          'layout service unavailable',
        )}`;
        input.disabled = true;
        cancelButton.textContent = 'Close';
        return;
      }
      if (document.body.contains(modal)) document.body.removeChild(modal);
    } catch (saveError) {
      error.textContent = errorText(saveError, 'Failed to save the chart layout.');
      saveButton.disabled = false;
    }
  };

  cancelButton.onclick = () => {
    if (document.body.contains(modal)) document.body.removeChild(modal);
  };

  buttonRow.append(saveButton, cancelButton);
  modal.append(label, input, error, buttonRow);
  document.body.appendChild(modal);
  input.focus();
  return modal;
}

export function addCustomButtons(widget, memberId, tvWidgetRef) {
  widget.headerReady().then(() => {
    widget.createButton({
      text: 'Layouts',
      title: 'Manage saved layouts',
      align: 'right',
      useTradingViewStyle: true,
      onClick: () => showLayoutManagerPopup(tvWidgetRef, memberId),
    });

    widget.createButton({
      text: 'Save',
      title: 'Save current chart layout',
      align: 'right',
      useTradingViewStyle: true,
      onClick: () => showSaveLayoutPopup(widget, memberId),
    });
  });
}
